module.exports = "<div id=\"{{$ctrl.cbName}}\" class=\"slider-v1\">\r\n  <div uib-carousel active=\"$ctrl.active\" no-pause=\"$ctrl.noPause\" interval=\"$ctrl.myInterval\" no-wrap=\"$ctrl.noWrapSlides\">\r\n    <div uib-slide ng-repeat=\"item in $ctrl.cbItems\" index=\"$index\">\r\n      <a href=\"{{item.url ? item.url : '#'}}\" title=\"{{item.title}}\">\r\n        <img ng-src=\"{{item.imageUrl}}\" target=\"{{item.url ? '_blank': '_self'}}\" class=\"img-responsive\">\r\n      </a>\r\n      <div class=\"carousel-caption\">\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/home/sliders/sliders-t1/sliders-t1.view.html
 ** module id = 341
 ** module chunks = 0
 **/